export type AlignmentType =
  | 'ALIGNMENT_UNKNOWN'
  | 'ALIGNMENT_START'
  | 'ALIGNMENT_CENTER'
  | 'ALIGNMENT_END';

export enum Alignment {
  ALIGNMENT_UNKNOWN = 'ALIGNMENT_UNKNOWN',
  ALIGNMENT_START = 'ALIGNMENT_START',
  ALIGNMENT_CENTER = 'ALIGNMENT_CENTER',
  ALIGNMENT_END = 'ALIGNMENT_END',
}
